export class ConfigService {
  static apiEndpoint = "https://ucontrol-test-api.bft-automation.com/";
  static apiEndpoint1 = "https://ucontrol-test-dispatcher.bft-automation.com/";
  static googleAnalyticsId = "";
  static googleMapsKey = "AIzaSyCPm738Y1l0291X4a7zBOb0kuUc7wEvjMA";

  static oauth = "oauth/token";
  static access = "access/create";
  static profile = "api/v1/users";
  static automations = "api/v1/automations";
  static automations1 = "automations";
  static users = "api/v1/users";

  static instance = new ConfigService();

  constructor() {
    if (process.env.BUILD_ENV === "staging") {
      ConfigService.apiEndpoint =
        "https://ucontrol-test-api.bft-automation.com/";
      ConfigService.apiEndpoint1 =
        "https://ucontrol-dispatcher-staging.bft-automation.com/";
      ConfigService.googleAnalyticsId = "UA-XXXXXXXXX-X";
    } else if (process.env.BUILD_ENV === "prod") {
      ConfigService.apiEndpoint = "https://ucontrol-api.bft-automation.com/";
      ConfigService.apiEndpoint1 =
        "https://ucontrol-dispatcher.bft-automation.com/";
      ConfigService.googleAnalyticsId = "UA-XXXXXXXXX-X";
    } else {
      ConfigService.apiEndpoint =
        "https://ucontrol-test-api.bft-automation.com/";
      ConfigService.apiEndpoint1 =
        "https://ucontrol-dispatcher-staging.bft-automation.com/";
      ConfigService.googleAnalyticsId = "UA-XXXXXXXXX-X";
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/services/configService.ts